export const truncateDecimal = (value: number | string, truncatePoint: number) => {
    const matchResult = value.toString().match(new RegExp(`^-?\\d+(?:\\.\\d{0,${truncatePoint}})?`));
    if (matchResult !== null) {
        return matchResult[0];
    } else {
        return '';
    }
}